
import ButtonIcon from "@/components/ButtonIcon.vue"
import HeaderLogo from "@/components/HeaderLogo.vue"

import { defineComponent } from "vue"

export default defineComponent({
  components: { HeaderLogo, ButtonIcon },
  setup() {},
})
